import React from 'react'

import { DataSelect } from 'components'

import { useProjectPhaseListQuery } from '../hooks'

export const ProjectPhaseDataSelect = React.forwardRef((props, ref) => {
  const { data, error, loading } = useProjectPhaseListQuery()

  return (
    <DataSelect
      valueAs='number'
      {...props}
      ref={ref}
      data={data}
      isError={error}
      isLoading={loading}
      valuePath='id'
      labelPath='name'
    />
  )
})

export default ProjectPhaseDataSelect
